export default function ({ $echo, $auth }) {
    if (!window.Pusher) window.Pusher = require('pusher-js')
    $echo.options.broadcaster = 'pusher'
    $echo.connect()
}
